<template>
  <div :class="currentPage === 'home' ? 'col-gap' : ''">
<!--    <toolbar-top-agency></toolbar-top-agency>-->

    <template v-if="getEnableMobileBottomToolbar === true">
      <toolbar-top></toolbar-top>
    </template>

    <SportCenterRouter />

    <v-snackbar v-model="getSnackbar">
      {{ $t(getSnackbarText) }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red darken-2" dark text v-bind="attrs" @click="closeSnackbar">
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <Legend v-if="viewLegend"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Legend from "./center_widgets/Legend";
import ToolbarTop from "./generic/ToolbarTop";
import ToolbarTopAgency from "./generic/ToolbarTopAgency";
import SportCenterRouter from "@/components/SportCenterRouter.vue";

export default {
  name: 'Center',
  components: {
    Legend,
    ToolbarTopAgency,
    ToolbarTop,
    SportCenterRouter,
  },
  data: () => ({
    viewLegend: false
  }),
  computed: {
    ...mapGetters({
      'getSnackbar': 'settings/getSnackbar',
      'getSnackbarText': 'settings/getSnackbarText',
      'getEnableMobileBottomToolbar': 'settings/getEnableMobileBottomToolbar',
    }),
    currentPage() {
      return this.$store.getters['sportNavigation/currentPage']
    },
  },
  methods: {
    ...mapActions({
      'setSnackbar': 'settings/setSnackbar',
    }),
    closeSnackbar() {
      this.setSnackbar(false)
    },
  },
}
</script>
